<template>
  <v-layout column>
    <v-flex>
      <template v-if="filteredDistributors.length > 0">
        <v-layout row class="px-3 align-center"
          style="background-color:#E4E4E4;height:3vw;min-height:30px;max-height:40px;border-bottom:2px lightgray solid;font-size:10px;"
        >
          <v-flex hidden-xs-only xs12 sm5 class="pl-2">
            <span>Distribuidora</span>
          </v-flex>
          <v-flex xs12 sm7 class="layout justify-center">
            <span>Indicadores</span>
            <!-- <v-layout row>
              <v-flex
                :key="card.cardType"
                v-for="card in enabledCards"
              >{{card.cardName}}</v-flex>
            </v-layout> -->
          </v-flex>
        </v-layout>
        <div
          :key="index"
          v-for="(item, index) in filteredDistributors" style="background-color:#F9F8F6;"
        >
          <distributor-detail-section
            :indicators="tooltips(item)"
            :detailed-distributor="detailedDistributor"
            :show-logs-details="showLogsDetails"
            :distributor="item"
          ></distributor-detail-section>
          <v-divider v-if="item !== filteredDistributors.length - 1"></v-divider>
        </div>

      </template>
      <template v-else>
        <v-container>
            <v-layout wrap>
              <v-flex style="color:rgba(0,0,0,.38)" class="align-center layout">
                No data available
              </v-flex>
            </v-layout>
          </v-container>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
import {map, filter, reduce, flatMap, orderBy} from 'lodash'

import cardsStorage from './../../storage/cardsStorage'
import supervisorStorage from './../../storage/supervisorStorage'

import DistributorDetailSection from './distributor-detail-section'

export default {
  data () {
    return {
      cards: [],
      distributors: []
    }
  },
  mounted () {
    this.cards = cardsStorage.getCardsPointer().cards
    this.distributors = supervisorStorage.getDistributorsPointer()
  },
  computed: {
    filteredDistributors () {
      let filteredDistributors = filter(this.distributors, (distributor) => {
        return distributor.distributorName.toLowerCase().indexOf((this.textFilter || '').toLowerCase()) !== -1 &&
          this.colorFilter(distributor)
      })
      return orderBy(filteredDistributors, this.totalDanger, 'desc')
    },
    enabledCards () {
      return filter(this.cards, (card) => card.enabled)
    }
  },
  methods: {
    colors (distributor) {
      return map(this.tooltips(distributor), (item, index) => ['', null, item.color.color].includes(this.colorsFilters[index].color))
    },
    colorFilter (distributor) {
      return reduce(this.colors(distributor), (total, item) => {
        return total && item
      }, true)
    },
    tooltips (distributor) {
      let indicators = []
      filter(this.cards, 'enabled').forEach((card) => {
        indicators.push({
          color: card.extra.indicator(distributor),
          text: card.cardName || '',
          type: card.cardType
        })
      })

      return indicators
    },
    totalDanger (distributor) {
      return reduce(flatMap(this.tooltips(distributor), 'color.dangerValue'), (total, item) => total + item, 0)
    },
    closeOthersFAB (index) {
      this.cards.forEach((card) => {
        card.extra.fab.active = false
      })
    },
    selectColor (card, index) {
      card.extra.fab.selectedIndex = index
    }
  },
  components: {
    DistributorDetailSection
  },
  props: {
    textFilter: {
      type: String,
      default () {
        return ''
      }
    },
    colorsFilters: {
      type: Array,
      default () {
        return []
      }
    },
    detailedDistributor: {
      type: Object,
      default () {
        return {}
      }
    },
    showLogsDetails: {
      type: Function,
      default () {
        return () => {}
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/supervisor/distributors-details-list.vue